exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-031d992f] {\n  max-width: 600px;\n}\n", ""]);

// exports
